<template>
	<div
		class="g-block-title-slant-lines g-block-title-padding"
		:class="{
			'g-block-title-slant-lines--edit': editable,
			'is-active': editable && active,
			'g-block-title-slant-lines--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-slant-lines__row">
			<span class="g-block-title-slant-lines__lead" :style="{ background: themeColor }"></span>
			<span class="g-block-title-slant-lines__slant g-block-title-slant-lines__slant--left" :style="{ borderColor: themeColor }"></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-slant-lines__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-slant-lines__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-slant-lines__slant g-block-title-slant-lines__slant--right" :style="{ borderColor: themeColor }"></span>
			<span class="g-block-title-slant-lines__trail" :style="{ background: lightColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleSlantLines',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-slant-lines {
		.title-block-edit-shell();
	}

	.g-block-title-slant-lines__row {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.g-block-title-slant-lines__lead {
		width: 24px;
		height: 2px;
		flex-shrink: 0;
	}

	.g-block-title-slant-lines__slant {
		width: 0;
		height: 18px;
		border-left: 2px solid;
		flex-shrink: 0;

		&--left {
			transform: skewX(-18deg);
			margin-right: 2px;
		}

		&--right {
			transform: skewX(-18deg);
			margin-left: 2px;
		}
	}

	.g-block-title-slant-lines__text {
		flex-shrink: 0;
		font-size: 20px;
		font-weight: 700;
		line-height: 1.3;
		padding: 0 4px;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-slant-lines__trail {
		flex: 1;
		height: 1px;
		min-width: 24px;
	}

	.g-block-title-slant-lines--h5 {
		.g-block-title-slant-lines__row { gap: 0.16rem; }
		.g-block-title-slant-lines__lead { width: 0.48rem; height: 0.04rem; }
		.g-block-title-slant-lines__slant { height: 0.36rem; border-left-width: 0.04rem; }
		.g-block-title-slant-lines__text { font-size: 0.4rem; padding: 0 0.08rem; }
		.g-block-title-slant-lines__trail { height: 0.02rem; }
	}
</style>
